import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icons/plus-gray.svg'
import _imports_1 from '@/assets/img/icons/check-success.svg'
import _imports_2 from '@/assets/img/icons/meatballs-menu.svg'
import _imports_3 from '@/assets/img/icons/set-default-gray.svg'
import _imports_4 from '@/assets/img/icons/edit-gray.svg'
import _imports_5 from '@/assets/img/icons/delete-red.svg'


const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_3 = { class: "grid grid-cols-3 gap-8" }
const _hoisted_4 = {
  key: 1,
  class: "grid grid-cols-3 gap-8"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "relative pt-4 px-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute flex justify-center w-full h-full top-0 left-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-20 h-20 mt-14",
      src: _imports_0
    })
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-full absolute bottom-0 left-0 border-t border-gray-100 text-base leading-7 font-semibold tracking-wider bg-white px-4 py-2" }, " Buat template baru ", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "relative pt-4 px-4" }
const _hoisted_10 = {
  class: "bg-white px-8 py-4 pb-16",
  style: {"font-size":"8px"}
}
const _hoisted_11 = { class: "bg-gray-100 py-2 px-4 text-center" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "w-20 h-20 mt-14",
  src: _imports_1
}
const _hoisted_14 = { class: "w-full absolute bottom-0 left-0 border-t border-gray-100 text-base leading-7 font-semibold tracking-wider bg-white px-4 py-2" }
const _hoisted_15 = { class: "flex gap-2 items-center justify-between" }
const _hoisted_16 = { class: "flex gap-2 items-center" }
const _hoisted_17 = {
  key: 0,
  class: "bg-secondary-gc rounded-full py-1 px-2 text-white text-xs"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createTextVNode(" Set as default ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
  /*#__PURE__*/_createTextVNode(" Edit ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-400" }, "Delete")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BDropdownItem = _resolveComponent("BDropdownItem")!
  const _component_BDropdown = _resolveComponent("BDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultTemplateLoadingCount, (n) => {
              return (_openBlock(), _createElementBlock("div", {
                key: n,
                class: "w-full bg-gray-200 h-56 rounded-lg"
              }))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.isAddable)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "shadow rounded-xl cursor-pointer bg-gray-100 overflow-hidden relative h-56 border border-transparent",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createAssessment && _ctx.createAssessment(...args)))
              }, _hoisted_7))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (assessment) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.selectAssessment(assessment.id)),
              key: assessment.id,
              class: _normalizeClass(["shadow rounded-xl cursor-pointer bg-gray-100 overflow-hidden relative h-56 border border-transparent", {
          'border-blue-700 shadow-lg': _ctx.isAssessmentChosen(assessment.id),
        }])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(assessment.subject || "HEADER"), 1),
                  _createElementVNode("div", {
                    innerHTML: assessment.body,
                    class: "py-4 no-style",
                    style: {"font-size":"8px"}
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["absolute flex justify-center w-full h-full top-0 left-0", {
              'bg-blue-700 bg-opacity-10': _ctx.isAssessmentChosen(assessment.id),
            }])
                }, [
                  (_ctx.isAssessmentChosen(assessment.id))
                    ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createTextVNode(_toDisplayString(assessment.name) + " ", 1),
                    (assessment.is_default === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Default "))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.isEditable)
                    ? (_openBlock(), _createBlock(_component_BDropdown, {
                        key: 0,
                        variant: "outline",
                        "no-caret": ""
                      }, {
                        "button-content": _withCtx(() => [
                          _hoisted_18
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_BDropdownItem, {
                            onClick: ($event: any) => (_ctx.setDefaultAssesment(assessment.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_BDropdownItem, {
                            onClick: ($event: any) => (_ctx.editAssesment(assessment.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          (assessment.is_default !== 1)
                            ? (_openBlock(), _createBlock(_component_BDropdownItem, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.deleteAssesment(assessment.id))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_21
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 10, _hoisted_8))
          }), 128))
        ]))
  ]))
}